module.exports = __webpack_public_path__ + "img/top.17d64323.png";